<template>
    <div>
        <user-avatar/>

        <section v-if="team" class="order order--membership">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle">Členství v týmu</h2>
                        <v-row v-if="team">
                            <v-col cols="16" offset="0" sm="12" offset-sm="2">
                                <v-data-table
                                    :headers="headers"
                                    :items="[team]"
                                    :hide-default-footer="true"
                                    :items-per-page="5"
                                    class="transparent"
                                >
                                    <template v-slot:item.name="{ item }">
                                        <div class="order__flex">
                                            <team-blazon-view :settings="item.blazon" class="small" />
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </template>
                                </v-data-table>
                                <v-btn type="submit" :to="{ name: 'myTeam' }" dark class="primary">
                                    Detail týmu
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <user-activation/>

        <user-change-password/>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import UserChangePassword from '../components/User/ChangePassword'
    import UserActivation from '../components/User/UserActivation';
    import UserAvatar from '../components/User/UserAvatar';
    import { MY_TEAM_REQUEST } from '../store/actions/team';
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView';

    export default {
        components: {
            TeamBlazonView,
            UserActivation,
            UserAvatar,
            UserChangePassword,
        },
        computed: {
            ...mapState({
                team: state => state.team.myTeam,
            }),
        },
        data () {
            return {
                readonlyInputTeamname: true,
                readonlyInputCity: true,
                readonlyInputTeamCaptain: true,
                headers: [
                    { text: 'Název týmu', value: 'name' },
                ],
            }
        },
        created () {
            this.$store.dispatch('team/' + MY_TEAM_REQUEST);
        },
    }
</script>
